/**
 * Közös oldalszélesség — a viewportot kitölti (max cap ultrawide-on), reszponzív padding.
 */
export const SITE_GUTTER_X = "px-4 sm:px-6 lg:px-8 xl:px-10";

/** Fő tartalom (nav, hero, készlet, footer, …) */
export const SITE_CONTAINER = `w-full max-w-[2400px] mx-auto ${SITE_GUTTER_X}`;

/** Bejelentkezés, jogi szöveg, keskenyebb fókusz */
export const SITE_CONTAINER_NARROW = `w-full max-w-3xl mx-auto ${SITE_GUTTER_X}`;

/** Űrlap / két oszlopos szekciók */
export const SITE_CONTAINER_FORM = `w-full max-w-6xl mx-auto ${SITE_GUTTER_X}`;

/** Készlet rács — MacBook ~5, PC több oszlop */
export const LISTING_CAR_GRID =
  "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-6 min-[2200px]:grid-cols-7 gap-4 sm:gap-5 xl:gap-4";

/** @deprecated — használd SITE_CONTAINER */
export const LISTING_SECTION_MAX_W = SITE_CONTAINER;
